module.exports = __webpack_public_path__ + "img/the_power_zone_banner.c44b43df.svg";